import appRoutes from "../routes/appRoutes";

export const COMMON_LINKS = [
  {
    name: "Home",
    to: appRoutes.rootPath(),
    exact: true,
  },
  {
    name: "Videos",
    to: appRoutes.videosPath(),
  },
  {
    name: "Artists",
    to: appRoutes.contentfulPagePath("artists-page"),
  },
];

export const NOT_AUTH_LINKS = [
  {
    name: "Sign Up",
    to: appRoutes.signUpPath(),
    activeLink: false,
    button: true,
  },
  {
    name: "Log In",
    to: appRoutes.loginPath(),
  },
];

export const AUTH_LINKS = [
  // JJR-171 New menu
  // {
  //   name: "Activity",
  //   to: appRoutes.activityPath(),
  // },
  {
    id: "my-ecards",
    name: "My Ecards",
    to: appRoutes.myEcardsPath(),
  },
  {
    id: "people",
    name: "People",
    to: appRoutes.peoplePath(),
  },
  {
    id: "account",
    name: "Account Settings",
    to: appRoutes.myAccountPath(),
  },
];
